
export default {
    name: 'ButtonGroups',
    model: {
        event: 'input',
        prop: 'selectedValue'
    },
    props: {
        selectedValue: {
            type: [Number, String, Boolean],
            default: 0,
            required: false
        }
    },
    data () {
        return {
            tabs: []
        }
    },
    watch: {
        selectedValue (val) {
            this.setSelected(val)
        }
    },
    created () {
        this.tabs = this.$children
    },
    mounted () {
        this.setSelected(this.selectedValue)
    },
    methods: {
        setSelected (selectedValue) {
            this.tabs.forEach((t, index) => {
                if (t.value === null) {
                    t.isSelected = (index === selectedValue)
                } else {
                    t.isSelected = (t.value === selectedValue)
                }
            })
        },
        checkSelected (e) {
            const el = 'isButtonGroup' in e.target.dataset ? e.target : e.target.closest('[data-is-button-group]')
            const selectedIndex = Array.from(this.$el.children).findIndex(ch => ch === el)
            const selectedTab = this.tabs[selectedIndex]
            const selectedValue = selectedTab.value === null ? selectedIndex : selectedTab.value
            if (selectedTab.selectable) {
                this.$emit('input', selectedValue)
            }
        }
    }
}
